<button type="button" (click)="copyToClipboard()" *ngIf="copy">
  <div #iconCopy class="icon-copy"></div> <span *ngIf="label">{{label}}</span>
</button>
